import React from 'react';
import styled from 'styled-components';
import MultiSelectOption from './MultiSelectOption';
import { useMultiSelect } from './MultiSelectProvider';

const List = styled.ul`
    display: flex;
    flex-direction: column;
    list-style-type: none;
    padding: 0;
    margin: 0;
`;

export default function MultiSelectOptions() {
    const { options } = useMultiSelect();

    return (
        <List>
            {options.map((option) => (
                <MultiSelectOption key={option.value} option={option} />
            ))}
        </List>
    );
}
